import React, { useCallback, useEffect, useRef, useState } from 'react';
import Button from '../CommonFields/Button'
import GemPack from '../../assets/images/gemsPack.svg'
import BuyBoxBtn from '../CommonFields/BuyBoxBtn'
import { useNavigate } from 'react-router'
import { routesFrontend } from '../RouterFiles/routes'
import { packList } from "../../api/coinStore.api";
import { url } from '../../config/url';
import ListLoader from '../Common/ListLoader';
import { t } from 'i18next';
const Packs = ({ isReedemPopup, setIsReedemPopup, reedemItem, setReedemItem, isReward, setIsReward, setIsBundle }) => {
    const naviagte = useNavigate()
    const [productList, setProductList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordPerPage, setRecordPerPage] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (currentPage <= totalPages)
            loadMore()
    }, [currentPage])

    const loadMore = async () => {
       
        fetchPacks()

    }

    const observer = useRef();
    const lastPostElementRef = useCallback(
        async (node) => {
            if (loading) return;
            if (observer.current) observer.current.disconnect();

            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    setCurrentPage((prevPage) => prevPage + 1);
                }
            });

            if (node) observer.current.observe(node);
        },
        [loading]
    );

    const fetchPacks = async () => {
        setLoading(true)
        try {
            let data = {
                pagination: {
                    pageNo: currentPage,
                    recordPerPage: recordPerPage,
                    sortBy: 'order',
                    sortDirection: "desc"
                }
            }

            const res = await packList(data);
            setLoading(false)
            if (res?.success && res?.data) {
                let list = []
                if (res?.data && res?.data?.length > 0) {
                    for (let i = 0; i < res?.data?.length; i++) {
                        let obj = { ...res?.data?.[i] }
                        obj.index = i + 1
                        list.push(obj)
                    }
                }

                if (currentPage == 1) {
                    setProductList(list);
                }
                else {
                    setProductList([...productList, ...list])
                }
                setTotalPages(res?.totalPages);
            }
            else {
                setProductList([]);
            }
        } catch (error) {
            setLoading(false)
        }
    };

    const verifyAccount = (reward) => {
        setIsReedemPopup(true);
        setIsReward(false);
        setIsBundle(false);
        setReedemItem(reward);
    }

    return (
        <>
            <div className='packs'>
                {
                   productList.length >0 ? productList.map((item, index) => {
                        return (
                            <div className='pack-box d-flex p-3 position-relative ' key={index} ref={productList?.length === index + 1 ? lastPostElementRef : null}>
                                {/* <div> */}
                                <img className='icon-38 me-3' src={url?.IMAGE_URL + item?.image?.default} alt={item?.name} />
                                <div className='text-packs d-flex flex-column'>
                                    <span className='mb-0 f-24'>{item?.coins}</span>
                                    <span className='mb-0'>{item?.name}</span>
                                </div>
                                {/* </div> */}

                                <div className='buy-box ' onClick={() => verifyAccount(item)}>
                                    <div class='buy-box-back-card'>

                                        <span className='f-12'>{t("rewards-store.buy_for")}</span>
                                        <span className='f-18 f-bold'>
                                            <span className='text-capitalize'>
                                                {item?.currency?.code === "INR" ?
                                                    item?.currency?.symbol
                                                    :
                                                    <img className='rewardstore-img-icon-size' src={url?.IMAGE_URL + item?.currency?.img?.default} alt={item?.name} />
                                                }
                                            </span>
                                            {" " + item?.amount}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        )
                    }) :!loading &&  <> <div className='no-record-found-center' style={{width:"100%"}}><span className="text-center">no data found</span></div></>
                }

{loading && <div className='w-100 d-flex justify-content-center'> <ListLoader/></div>}
            </div>
            <div className='btn-recent-trns w-100 mb-4'>
                <Button text={t("rewards-store.my_recent_transactions")} onClick={() => naviagte(routesFrontend.myRecentTransaction)} />
            </div>
        </>
    )
}

export default Packs